module.exports = __webpack_public_path__ + "static/media/segment-logo.0ac53931.svg";